export interface NewReview {
  productID: number;
  rating: number;
  comment: string;
}

export const newReviewOutputTransformer = (newReview: NewReview) => ({
  product_id: newReview.productID,
  rating: newReview.rating,
  comment: newReview.comment,
});

export const getEmptyNewReview = (productID: number): NewReview => ({
  productID,
  rating: 5,
  comment: '',
});
